import { z } from 'zod';

export const CompletionNotificationRecipientSchema = z.object({
  id: z.number(),
  contactId: z.number(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  email: z.string(),
  customerId: z.number(),
  customerName: z.string().nullable(),
});

export type CompletionNotificationRecipientDto = z.infer<
  typeof CompletionNotificationRecipientSchema
>;

export const CompletionNotificationSchema = z.object({
  id: z.number(),
  completionEventId: z.number(),
  status: z.enum(['DRAFT', 'SENT']),
  subject: z.string().nullable(),
  body: z.string().nullable(),
  sentAt: z.coerce.date().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  recipients: z.array(CompletionNotificationRecipientSchema),
});

export type CompletionNotificationDto = z.infer<typeof CompletionNotificationSchema>;

export const CreateCompletionNotificationSchema = z.object({
  completionEventId: z.number(),
  subject: z.string().optional(),
  body: z.string().optional(),
  recipientContactIds: z.array(z.number()),
});

export type CreateCompletionNotificationDto = z.infer<typeof CreateCompletionNotificationSchema>;

export const UpdateCompletionNotificationSchema = z.object({
  subject: z.string().optional(),
  body: z.string().optional(),
  recipientContactIds: z.array(z.number()).optional(),
});

export type UpdateCompletionNotificationDto = z.infer<typeof UpdateCompletionNotificationSchema>;

export const SendCompletionNotificationSchema = z
  .object({
    closeIdea: z.boolean().optional(),
    includeOwner: z.boolean().optional(),
  })
  .default({});

export type SendCompletionNotificationDto = z.infer<typeof SendCompletionNotificationSchema>;

export const GetCompletionNotificationResponseSchema = CompletionNotificationSchema;
export type GetCompletionNotificationResponseDto = CompletionNotificationDto;

export const GetCompletionNotificationsResponseSchema = z.array(CompletionNotificationSchema);
export type GetCompletionNotificationsResponseDto = z.infer<
  typeof GetCompletionNotificationsResponseSchema
>;
